import _ from "lodash";
import {
  ALREADY_REGISTERED_LABEL,
  PROGRAM_SPECIFIC_NAMES,
} from "../../../Helpers/constants";
import { getUserData } from "../../../Helpers/utils";

/** Builds `pageContext` for RichText interpolation (email, messages from storage, etc.). */
export function buildDxpStaticPageContext(
  overrides: Record<string, unknown> = {},
): Record<string, unknown> {
  const userData = getUserData();
  let email = userData?.email || "";
  const searchedEmail = localStorage.getItem("email") || "";
  if (!email) {
    email = searchedEmail;
  }
  const company = localStorage.getItem("companyName");
  const alreadyRegisteredWith =
    localStorage.getItem("alreadyRegisteredWith") || "";
  const alreadyRegisteredWithLabel = _.get(
    ALREADY_REGISTERED_LABEL,
    alreadyRegisteredWith,
    alreadyRegisteredWith,
  );
  const mainMessage = localStorage.getItem("mainMessage");
  const subMessage = localStorage.getItem("subMessage");
  const statusMessage = localStorage.getItem("statusMessage");

  return {
    ...(PROGRAM_SPECIFIC_NAMES.DXP || {}),
    ...(email && { email }),
    ...(searchedEmail && { searchedEmail }),
    ...(company && { company }),
    ...(alreadyRegisteredWithLabel && { alreadyRegisteredWithLabel }),
    ...(mainMessage && { mainMessage }),
    ...(subMessage && { subMessage }),
    ...(statusMessage && { statusMessage }),
    ...overrides,
  };
}
